<template>
  <div :class="customClass">
    <div class="text-center mx-5 mt-0">
      <i
        class="material-icons border-2 full-icon rounded-circle align-middle mt-5 mb-4 opacity-1"
      >
        {{ icon }}
      </i>

      <p class="h5 text-muted font-weight-normal opacity-1">
        {{ title }}
      </p>
      <b-button
        v-if="goFunction"
        variant="warning"
        block
        class="my-3"
        @click="goFunction"
      >
        Create
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    customClass:String,
    icon: String,
    title: String,
    goFunction: Function
  }
};
</script>
<style scoped>
.border-2 {
  background-color: #f2f2f2;
  border: 1px solid #cccccc;
  color: #999999;
  font-size: 1.2em !important;
  padding: 0.1em !important;
}
.full-icon {
  font-size: 8em !important;
  color: #e6e6e6;
}
.opacity-1 {
  opacity: .5;
}
</style>
